import { FC, useEffect } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuestion } from 'store/quiz/quizSelectors';
import IQuestion from 'models/Question';
// Components
import Dialog from 'components/Dialog';
import { Button } from 'components/Buttons';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  onClose: () => void;
}

let interval:NodeJS.Timeout | null = null;

const CorrectAnswerDescriptionDialog:FC<Props> = ({ onClose }) => {
  const { t } = useTranslation();

  const question:IQuestion = useAppSelector(selectQuestion);

  const correctAnswer = question.answers.find(answer => answer.correct);

  useEffect(() => {
    interval = setInterval(() => {
      onClose();
    }, 5000);

    return () => {
      if (interval) clearInterval(interval);
    }
    // eslint-disable-next-line
  }, []);

  if (!question.correctAnswerDescription || !correctAnswer) return null;
  return (
    <Dialog background='none' classes="backdrop-blur-sm">
      <div className="relative mx-4 p-4 border border-white rounded-xl bg-[#212938]">
        <h3 className="text-lg text-white mb-4">
          {t('dialogs.correctAnswerDescription.title', { title: correctAnswer.title })}
        </h3>
        <p className="text-sm text-white font-bold mb-4">{question.correctAnswerDescription}</p>
        <Button
          size="small"
          onClick={onClose}
          className="bg-linear-orange flex items-center gap-2 mx-auto"
        >
          {t('buttons.next')}
        </Button>
      </div>
    </Dialog>
  )
}

export default CorrectAnswerDescriptionDialog;
